import script from "./SubscribeNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribeNotification.vue?vue&type=script&setup=true&lang=js"

import "./SubscribeNotification.vue?vue&type=style&index=0&id=5edd1243&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5edd1243"]])

export default __exports__